import { Widths } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { User } from "../external-sources/Users";
import { Modes } from "./mode";

export const description: FieldSchema = {
  name: "description",
  grid: {
    displayed: true,
    order: 77,
  },
  data: { maxLength: 40 },
  display: {
    displayed: true,
  },
  form: {
    label: "Description",
    width: Widths.DOUBLE,
    disabled: {
      getter: ({ linkedInstance, mode, currentUser }) => {
        return (
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["linkedInstance", "mode", "currentUser"],
    },
  },
};
